import { render, staticRenderFns } from "./MyTrainingDetail.vue?vue&type=template&id=081bb520&scoped=true"
import script from "./MyTrainingDetail.vue?vue&type=script&lang=js"
export * from "./MyTrainingDetail.vue?vue&type=script&lang=js"
import style0 from "./MyTrainingDetail.vue?vue&type=style&index=0&id=081bb520&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081bb520",
  null
  
)

export default component.exports